import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import 'util/font_style_module/fontStyle.css';
import ScrollToTop from 'components/scroll_top';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
  <ScrollToTop />
    <App />
  </BrowserRouter>
);

reportWebVitals();
